import React, { useMemo } from 'react'

import { Typography } from 'antd'

import { getMessage } from '../../../../../../util/IntlMessages'
import { useGetFieldTypesQuery } from '../../services/fieldType'
import { useManageField } from '../../hooks/useManageFields'
import { fieldTypes } from './data'

import './styles.less'

export function ComponentsMenu() {
  const { data } = useGetFieldTypesQuery()

  const { createField } = useManageField()

  const mappedFields = useMemo(() => {
    const fieldTypesFromDB = data?.items || []

    return fieldTypes.map((fieldType) => {
      const fieldTypeId =
        fieldTypesFromDB.find((dbFieldType) => dbFieldType.internalTypeName === fieldType.internalTypeName)?.id || null
      return { ...fieldType, fieldTypeId }
    })
  }, [data])

  async function addField(field) {
    await createField({ field })
  }

  return (
    <div className="componentsMenu">
      <Typography className="componentsMenu__title">{getMessage('addComponent')}</Typography>

      <div className="horizontal-line nav-item-separator" />
      {mappedFields.map(({ id, ...field }) => (
        <div key={id}>
          <a className="componentsMenu__item" onClick={() => addField({ ...field })}>
            <img
              className="componentsMenu__itemIcon"
              src={require(`../../../../../../assets/images/${field.internalTypeName}.png`)}
              alt="item-icon"
            />
            <Typography.Text>{field.fieldName}</Typography.Text>
          </a>
          <div className="horizontal-line nav-item-separator" />
        </div>
      ))}
    </div>
  )
}
